export const Colors = {
  primary: '#FF006E', 
  primaryDark: '#D1005A',
  primaryLight: '#FF3399',
  primaryLighter: '#FF66B3',
  primaryLightest: '#FFE6F2',
  secondary: '#1F1F1F',
  secondaryDark: '#000000',
  secondaryLight: '#333333',
  accent: '#FF006E',
  accentDark: '#D1005A',
  accentLight: '#FF3399',
  white: '#FFFFFF',
  black: '#000000',
  gray: '#F5F5F5',
  grayLight: '#FAFAFA',
  grayMedium: '#E5E5EA',
  darkGray: '#8E8E93',
  lightGray: '#E5E5EA',
  border: '#E0E0E0',
  borderLight: '#F0F0F0',
  success: '#34C759',
  successLight: '#5CD97F',
  successDark: '#28A745',
  error: '#FF3B30',
  errorLight: '#FF6B63',
  errorDark: '#DC3545',
  warning: '#FF9500',
  warningLight: '#FFB340',
  warningDark: '#E68900',
  info: '#007AFF',
  infoLight: '#3395FF',
  infoDark: '#0056CC',
  background: '#FFFFFF',
  backgroundSecondary: '#F8F8F8',
  backgroundDark: '#1A1A1A',
  surface: '#FFFFFF',
  surfaceElevated: '#FFFFFF',
  surfaceDark: '#2C2C2E',
  text: '#000000',
  textPrimary: '#000000',
  textSecondary: '#8E8E93',
  textTertiary: '#C7C7CC',
  textInverse: '#FFFFFF',
  divider: '#E5E5EA',
  overlay: 'rgba(0, 0, 0, 0.5)',
  overlayLight: 'rgba(0, 0, 0, 0.3)',
  shadow: 'rgba(0, 0, 0, 0.1)',
  shadowDark: 'rgba(0, 0, 0, 0.2)',
  shadowPrimary: 'rgba(255, 0, 110, 0.2)',
};

export const Shadows = {
  small: {
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
  },
  medium: {
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  large: {
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
  },
  xlarge: {
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  },
  primary: {
    boxShadow: '0 4px 12px rgba(255, 0, 110, 0.3)',
  },
};

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

export const BorderRadius = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  round: 9999,
};

export const Typography = {
  h1: {
    fontSize: '32px',
    fontWeight: 800,
    lineHeight: '40px',
    letterSpacing: '-0.5px',
  },
  h2: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: '36px',
    letterSpacing: '-0.3px',
  },
  h3: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px',
    letterSpacing: '0px',
  },
  h4: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px',
    letterSpacing: '0.2px',
  },
  body: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  bodyBold: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
  caption: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  captionBold: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  small: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
  },
  smallBold: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
  },
};

